/**
 * Created by Administrator on 2018/3/9.
 */
const state = {
  keepDecs: [],
  tableOption: []
};
const mutations = {};
const actions = {};
const getters = {};
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/managers/vuex/modules/table.js